import { Selector, createSelector } from '@reduxjs/toolkit'
import { EntityType, TradingControlLimitDetail } from 'api'
import { GlobalState } from 'store'
import { createAllEntityUpdatesSelector, createEntityGetterSelector, createAllEntitiesSelector } from './entitySelectors'
import { currentOrganisationIdSelector } from 'selectors/adminSelectors'
import { canManageTradingControlLimitSelector, canViewTradingControlLimitSelector } from './permissionSelectors'
import { isAdminGatewayUserSelector } from './userSelectors'

export const tradingControlLimitDetailsSelector: Selector<GlobalState, TradingControlLimitDetail[]> = createSelector(
  createAllEntityUpdatesSelector(EntityType.TRADING_CONTROL_LIMIT),
  createEntityGetterSelector(EntityType.ORGANISATION),
  (tradingControlLimitUpdates, getOrganisation) => {
    return tradingControlLimitUpdates.map(update => {
      const tradingControlLimit = update.entity
      const availableEvents = update.availableEvents
      return {
        tradingControlLimit,
        organisation: getOrganisation(tradingControlLimit.organisationId),
        availableEvents
      }
    })
  }
)

export const canOrganisationViewTradingControlLimitSelector: Selector<GlobalState, boolean> = createSelector(
  canViewTradingControlLimitSelector,
  currentOrganisationIdSelector,
  createAllEntitiesSelector(EntityType.TRADING_CONTROL_LIMIT),
  isAdminGatewayUserSelector,
  (canViewTradingControlLimit, currentOrganisationId, tradingControlLimits, isAdminUser) => {
    return (
      canViewTradingControlLimit &&
      (isAdminUser || tradingControlLimits.some(tradingControlLimit => tradingControlLimit.organisationId === currentOrganisationId))
    )
  }
)

export const canViewControlLimitNavLinkSelector: Selector<GlobalState, boolean> = createSelector(
  canOrganisationViewTradingControlLimitSelector,
  canManageTradingControlLimitSelector,
  (canOrganisationViewTradingControlLimit, canManageTradingControlLimit) =>
    canManageTradingControlLimit || canOrganisationViewTradingControlLimit
)
